//@flow

import type {ScheduleMessage} from '../../../entities';
import {ActionCreator, createReducer} from '../../../store/utils';

export type ScheduleMessageState = {
  scheduleMessages: ScheduleMessage[],
  currentConversationScheduleMessages?: ScheduleMessage[],
};
export type ScheduleMessageAction = {
  scheduleMessages?: ScheduleMessage[],
  scheduleMessage?: ScheduleMessage,
  scheduleMessageId?: string,
};

export const initialState: ScheduleMessageState = {
  scheduleMessages: [],
  currentConversationScheduleMessages: [],
};

export class SetScheduleMessages extends ActionCreator<ScheduleMessageAction> {}

export class SetCurrentConversationScheduleMessages extends ActionCreator<ScheduleMessageAction> {}

export class CreateScheduleMessages extends ActionCreator<ScheduleMessageAction> {}

export class EditScheduleMessages extends ActionCreator<ScheduleMessageAction> {}

export class DeleteScheduleMessages extends ActionCreator<ScheduleMessageAction> {}

export const actions = {
  setScheduleMessages: (scheduleMessages: ScheduleMessage[]) =>
    new SetScheduleMessages({scheduleMessages}),

  setCurrentConversationScheduleMessages: (
    scheduleMessages: ScheduleMessage[]
  ) => new SetCurrentConversationScheduleMessages({scheduleMessages}),

  createScheduleMessages: (scheduleMessage: ScheduleMessage) =>
    new CreateScheduleMessages({scheduleMessage}),
  editScheduleMessages: (scheduleMessage: ScheduleMessage) =>
    new EditScheduleMessages({scheduleMessage}),

  deleteScheduleMessages: (scheduleMessageId: string) =>
    new DeleteScheduleMessages({scheduleMessageId}),
};

export default createReducer<ScheduleMessageState>(initialState, {
  [SetScheduleMessages.type]: (state, {scheduleMessages}) => ({
    ...state,
    scheduleMessages: scheduleMessages || [],
  }),

  [CreateScheduleMessages.type]: (state, {scheduleMessage}) => {
    return {
      ...state,
      scheduleMessages: [...state.scheduleMessages, scheduleMessage],
      currentConversationScheduleMessages: [
        ...state.currentConversationScheduleMessages,
        scheduleMessage,
      ],
    };
  },
  [EditScheduleMessages.type]: (state, {scheduleMessage}) => ({
    ...state,
    scheduleMessages: state.scheduleMessages.map(item =>
      item.id === scheduleMessage.id ? scheduleMessage : item
    ),
    currentConversationScheduleMessages: state.currentConversationScheduleMessages.map(
      item => (item.id === scheduleMessage.id ? scheduleMessage : item)
    ),
  }),
  [DeleteScheduleMessages.type]: (state, {scheduleMessageId}) => ({
    ...state,
    scheduleMessages: state.scheduleMessages.filter(
      item => item.id !== scheduleMessageId
    ),
    currentConversationScheduleMessages: state.currentConversationScheduleMessages.filter(
      item => item.id !== scheduleMessageId
    ),
  }),
  [SetCurrentConversationScheduleMessages.type]: (
    state,
    {scheduleMessages}
  ) => ({
    ...state,
    currentConversationScheduleMessages: scheduleMessages || [],
  }),
});
